import { Facebook, Mail, MapPin, Phone } from "lucide-react";
import { assets, club } from "../../data/sep26Data";

export const Footer26 = () => (
  <footer data-testid="s26-footer" className="border-t" style={{ borderColor: "var(--line)", background: "var(--navy-deep)" }}>
    <div className="wrap grid gap-12 py-16 md:grid-cols-[1.2fr_1fr_1fr]">
      <div className="flex items-start gap-5">
        <img src={assets.crest} alt="" width="72" height="85" className="h-20 w-auto" />
        <div>
          <p className="display text-3xl">Arsenal<br />de Allende</p>
          <p className="serif mt-3" style={{ color: "var(--muted)" }}>{club.slogan}</p>
        </div>
      </div>

      <div>
        <p className="label mb-4" style={{ color: "var(--gold)" }}>Contacto</p>
        <ul className="space-y-3" style={{ color: "var(--muted)" }}>
          <li className="flex items-start gap-2"><Mail size={16} className="mt-1 shrink-0" aria-hidden="true" /> <a href={`mailto:${club.email}`}>{club.email}</a></li>
          <li className="flex items-start gap-2"><Phone size={16} className="mt-1 shrink-0" aria-hidden="true" /> <a href={`tel:${club.phone.replace(/\s/g, "")}`}>{club.phone}</a></li>
          <li className="flex items-start gap-2"><MapPin size={16} className="mt-1 shrink-0" aria-hidden="true" /> {club.venue}</li>
        </ul>
      </div>

      <div>
        <p className="label mb-4" style={{ color: "var(--gold)" }}>Síguenos</p>
        <a
          href={club.facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn--ghost"
          data-testid="s26-social-facebook"
        >
          <Facebook size={18} aria-hidden="true" /> Facebook
        </a>
      </div>
    </div>
    <div className="wrap flex flex-wrap justify-between gap-3 border-t py-6 text-sm" style={{ borderColor: "var(--line)", color: "var(--muted)" }}>
      <span>© {new Date().getFullYear()} {club.name}</span>
      <span>{club.category} · {club.modality}</span>
    </div>
  </footer>
);
